import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import projects from "../../data/projects";

function Projects() {
  return (
    <Container as="main" fluid className="project-section">
      <Container>
        <div className="section-header">
          <h1 className="section-heading">Projects</h1>
        </div>
        <Row className="g-4 project-grid">
          {projects.map((project) => (
            <Col md={6} xl={4} key={project.title} className="project-card">
              <ProjectCard {...project} />
            </Col>
          ))}
        </Row>
        <div className="project-resources">
          <a href="https://github.com/dixonfrederick" target="_blank" rel="noreferrer">
            All Repositories on GitHub
          </a>
          <a href="https://medium.com/@dixon.frederick" target="_blank" rel="noreferrer">
            Technical Writing on Medium
          </a>
        </div>
      </Container>
    </Container>
  );
}

export default Projects;
